// Display only: never replace provider IDs or parameter values in API requests.
const providers: Record<string, string> = {
  volcengine: '火山引擎', volc: '火山引擎', doubao: '豆包',
  minimax: '稀宇科技', dashscope: '阿里云百炼', aliyun: '阿里云',
  tencent: '腾讯云', hunyuan: '腾讯混元', zhipu: '智谱',
  deepseek: '深度求索', baidu: '百度智能云', siliconflow: '硅基流动',
  openai: 'OpenAI', anthropic: 'Anthropic',
  google: '谷歌', gemini: '谷歌', '文本聚合': '文本调用',
}
const values: Record<string, string> = {
  generate: '生成', edit: '编辑', reference_to_video: '参考素材生成视频', first_last_frame: '首尾帧生成视频',
  image_to_video: '图片生成视频', text_to_video: '文字生成视频',
  text_to_image: '文字生成图片', image_to_image: '图片生成图片',
  adaptive: '自适应', auto: '自动', low: '低', medium: '中', high: '高',
  true: '开启', false: '关闭', settled: '已结算', not_dispatched: '未调用',
  pending: '待处理', failed: '失败', succeeded: '成功', completed: '已完成',
  running: '进行中', reserved: '已预留', dispatched: '已调用',
  text: '文本', image: '图片', video: '视频', audio: '音频',
  assistant: '助手', user: '用户', system: '系统', zh: '中文', en: '英文',
}
export const providerName = (value: string) => providers[value.toLowerCase()] || value
export const parameterValue = (value: unknown): string => {
  if (value && typeof value === 'object') return Object.entries(value).map(([key, item]) => `${values[key] || key}：${parameterValue(item)}`).join('、')
  return values[String(value)] || String(value)
}
export const parameterText = (text: string) => text.replace(/\b[a-z][a-z_]*\b/g, value => values[value] || value)
